module.exports = __webpack_public_path__ + "static/media/38.c52842fd.mp3";